import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
const BrandLogo = ({ className }) => <img src="/praniq-logo.png" alt="PranIQ" className={className} data-testid="login-brand-logo" />;
import { useAuth } from "@/context/Auth";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); nav("/"); } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-white">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-slate-50 grid-bg border-r border-slate-200">
        <BrandLogo className="h-12 w-auto self-start" />
        <div className="max-w-lg">
          <p className="eyebrow mb-4">Clinical governance · India & Malaysia</p>
          <h1 className="font-heading text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">One governed source of truth for every rehab protocol.</h1>
          <p className="mt-5 text-slate-600 leading-relaxed">Author, review, approve and publish versioned protocols — then serve them to doctor, clinician and patient portals and as verifiable PDFs.</p>
          <div className="mt-8 flex flex-wrap gap-2 text-[11px] font-mono text-slate-500">
            {["draft", "in_review", "approved", "published", "superseded", "retired"].map((s) => <span key={s} className="rounded border border-slate-300 bg-white px-2 py-1">{s}</span>)}
          </div>
        </div>
        <p className="text-[11px] text-slate-400">PranIQ Health Tech Private Limited · www.praniq.life · No patient-identifiable data is held in this repository.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-in" data-testid="login-form">
          <BrandLogo className="h-14 w-auto" />
          <div>
            <h2 className="font-heading text-2xl font-bold text-slate-900">Sign in</h2>
            <p className="text-sm text-slate-500 mt-1">Accounts are issued by your PranIQ admin.</p>
          </div>
          <div className="space-y-1.5">
            <label className="eyebrow">Email</label>
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full h-10 rounded border border-slate-300 px-3 text-sm outline-none focus:border-sky-500" />
          </div>
          <div className="space-y-1.5">
            <label className="eyebrow">Password</label>
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full h-10 rounded border border-slate-300 px-3 text-sm outline-none focus:border-sky-500" />
          </div>
          <button data-testid="login-submit-btn" disabled={busy} className="w-full h-10 rounded bg-sky-600 text-white text-sm font-semibold hover:bg-sky-700 transition-colors disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
